import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useContext } from 'react';
import { AuthContext } from '../AuthContext';

const HeaderNav = ({ connectWallet }) => {
  const { logout, isAuthenticated, ensName, address, loginWithSIWE, bankSystemWallet, authStatus } = useContext(AuthContext);
  const navigate = useNavigate();
  const [integrationStatus, setIntegrationStatus] = useState('ready');

  useEffect(() => {
    if (
      !isAuthenticated &&
      window.location.pathname !== '/' &&
      !window.location.pathname.includes('/landing')
    ) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  // Cross-app communication setup - FIXED VERSION
  useEffect(() => {
    const handleMessage = (event) => {
      // Only process messages from banksystem.co domains
      if (event.origin.includes('banksystem.co')) {
        console.log('📨 Main app received message:', event.data);

        switch (event.data.type) {
          case 'WALLET_APP_READY':
            console.log('✅ Wallet app is ready and responsive');
            setIntegrationStatus('wallet-ready');
            break;

          case 'WALLET_CREATED':
            console.log('🎉 Wallet created in wallet app:', event.data.address);
            setIntegrationStatus('wallet-created');
            // Don't reload immediately - let user see the success
            setTimeout(() => {
              window.location.reload();
            }, 3000);
            break;

          case 'WALLET_CONNECTED':
            console.log('🔗 Wallet connected in wallet app:', event.data.address);
            setIntegrationStatus('wallet-connected');
            // Close the wallet window and refresh main app
            if (event.source && event.source.close) {
              event.source.close();
            }
            setTimeout(() => {
              window.location.reload();
            }, 1000);
            break;

          case 'WALLET_UNLOCKED':
            console.log('🔓 Wallet unlocked in wallet app:', event.data.address);
            setIntegrationStatus('wallet-unlocked');
            // AuthContext will handle the actual login, we just update status
            break;

          case 'DOMAIN_MINTED':
            setIntegrationStatus('domain-minted');
            setTimeout(() => {
              window.location.reload();
            }, 2000);
            break;

          default:
            console.log('📨 Unknown message type:', event.data.type);
            break;
        }
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [isAuthenticated, ensName, address]);

  const handleLogout = () => {
    logout();
  };

  // ✅ FIXED: handleConnectWeb3 function with cache-busting and better error handling
  const handleConnectWeb3 = async () => {
    try {
      console.log('🔗 Connect Web3 clicked - opening wallet in unlock mode');

      // 🔥 CRITICAL FIX: Add cache-busting and ensure wallet app loads
      const timestamp = Date.now();
      const walletUrl = `https://banksystem.co/banksystem/?mode=connect&ts=${timestamp}&source=mainapp&forceWallet=true&cachebuster=${Math.random()}`;

      console.log('🎯 Opening wallet URL:', walletUrl);

      // Open in a specific size for wallet unlock mode
      const walletWindow = window.open(
        walletUrl,
        'BankSystemWallet',
        'width=500,height=400,menubar=no,toolbar=no,location=no,status=no'
      );

      if (!walletWindow) {
        console.error('❌ Popup blocked! Please allow popups for BankSystem.');
        alert('Popup blocked! Please allow popups for BankSystem to open the wallet.');
        return;
      }

      console.log('✅ Wallet window opened successfully');

      // 🔥 ADDED: Verify the correct app loaded
      const checkAppLoaded = setInterval(() => {
        try {
          // Check if wallet window loaded the correct app
          if (walletWindow.closed) {
            clearInterval(checkAppLoaded);
            return;
          }

          // This will throw an error if cross-origin, but that's fine
          // The important thing is that the wallet window opened
          console.log('✅ Wallet window is open and running');
          clearInterval(checkAppLoaded);
        } catch (error) {
          // Cross-origin error is expected and means the app loaded
          console.log('✅ Wallet app loaded in separate window');
          clearInterval(checkAppLoaded);
        }
      }, 1000);

    } catch (error) {
      console.error('❌ Connect failed:', error);
      alert('Failed to open wallet: ' + error.message);
    }
  };

  const createWallet = () => {
    // 🔥 UPDATED: Add cache-busting to create wallet too
    const timestamp = Date.now();
    const walletUrl = `https://banksystem.co/banksystem/?ts=${timestamp}&cachebuster=${Math.random()}`;
    window.open(walletUrl, '_blank');
  };

  const mintDomain = () => {
    window.open('https://banksystem.co/identity/', '_blank');
  };

  const isConnected = isAuthenticated;
  const displayName = isConnected
    ? ensName || (address ? `${address.substring(0, 6)}...` : 'Connected')
    : '';

  const handleBrandClick = () => {
    navigate('/');
  };

  return (
    <header className="nav">
      <style>{`
        .nav-content {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .logo {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }
        .gold-logo {
          font-family: inherit;
          font-size: 1.54em;
          font-weight: bold;
          color: #FFD700;
          letter-spacing: 1px;
          line-height: 1.1;
          cursor: pointer;
          transition: text-shadow 0.3s, filter 0.3s;
          text-shadow: 0 0 8px #ffec8b80, 0 0 3px #FFD70090;
          user-select: none;
        }
        .gold-logo:hover, .gold-logo:focus {
          filter: brightness(1.18) drop-shadow(0 0 8px #fffbe6cc);
          text-shadow: 0 0 18px #fffbe699, 0 0 3px #FFD700;
          outline: none;
        }
        .subtitle-btn-color {
          color: #880808;
        }
        .nav-links {
          display: flex;
          align-items: center;
        }
        .plain-gold-link {
          color: #FFD700;
          font-weight: bold;
          font-size: 1em;
          margin-right: 18px;
          text-decoration: none;
          background: none;
          border: none;
          cursor: pointer;
          padding: 0;
          transition: color 0.2s, text-decoration 0.2s;
        }
        .plain-gold-link:hover, .plain-gold-link:focus {
          color: #fffbe6;
          text-decoration: underline;
          outline: none;
        }
        .btn.btn-dark-red,
        .btn-dark-red, .equal-btn {
          min-width: 140px;
          height: 40px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background: #880808;
          color: #fff;
          border: 1px solid #fff;
          border-radius: 6px;
          font-size: 1em;
          font-weight: 500;
          margin-left: 8px;
          margin-right: 0;
          box-sizing: border-box;
          padding: 0 18px;
          cursor: pointer;
          transition: background 0.2s, color 0.2s, border 0.2s, box-shadow 0.2s;
        }
        .btn.btn-dark-red:hover,
        .btn-dark-red:hover, .equal-btn:hover {
          background: #a90000;
          color: #FFD700;
          border: 1px solid #FFD700;
          box-shadow: 0 0 8px 2px #FFD70055;
        }
      `}</style>

      {/* Debug Status Display */}
      <div style={{
        position: 'fixed',
        top: '10px',
        right: '10px',
        background: '#333',
        color: '#fff',
        padding: '10px',
        borderRadius: '5px',
        fontSize: '12px',
        zIndex: 10000,
        maxWidth: '300px',
        border: '1px solid #FFD700'
      }}>
        <div><strong>Auth Status:</strong> {authStatus}</div>
        <div><strong>Connected:</strong> {isAuthenticated ? 'Yes' : 'No'}</div>
        <div><strong>ENS:</strong> {ensName || 'None'}</div>
        <div><strong>Wallet:</strong> {bankSystemWallet?.address ? `${bankSystemWallet.address.slice(0, 8)}...` : 'None'}</div>
        <div><strong>Integration:</strong> {integrationStatus}</div>
      </div>

      <div className="container nav-content">
        <div className="logo">
          <span
            className="gold-logo"
            tabIndex={0}
            onClick={handleBrandClick}
            onKeyDown={e => { if (e.key === 'Enter') handleBrandClick(); }}
            title="Go to Home"
          >
            BankSystem.eth
          </span>
          <span className="subtitle-btn-color" style={{ fontSize: '0.7em' }}>
            Unlock Exclusive Blockchain Finance: Mint Your .xbsys.eth Domain for Access!
          </span>
        </div>
        <div className="nav-links">
          <Link
            to="/web3broker"
            className="plain-gold-link nav-link"
            title="Visit Web3Broker within app"
          >
            Powered by Ethereum
          </Link>
          {!isConnected ? (
            <button className="btn btn-dark-red equal-btn" onClick={handleConnectWeb3}>
              Connect Web3
            </button>
          ) : (
            <button className="btn btn-dark-red equal-btn" onClick={handleLogout}>
              Logout
            </button>
          )}
          <button
            className="btn btn-dark-red equal-btn"
            onClick={createWallet}
            title="Create BankSystem Wallet - No ENS Required"
          >
            Create Wallet
          </button>

          {/* Temporary Debug Button */}
          <button
            className="btn btn-dark-red equal-btn"
            onClick={() => {
              const timestamp = Date.now();
              const walletUrl = `https://banksystem.co/banksystem/?debug=direct&ts=${timestamp}&cachebuster=${Math.random()}`;
              window.open(walletUrl, '_blank');
            }}
            style={{ marginLeft: '10px', background: '#006400' }}
            title="Open Wallet Directly with Cache Busting"
          >
            🚨 Open Wallet
          </button>
        </div>
      </div>
      {isConnected && (
        <div style={{ textAlign: 'center', marginTop: '10px', color: '#FFD700' }}>
          Wallet Connected: {displayName} {isAuthenticated ? '(Authenticated)' : '(Not Authenticated)'}
        </div>
      )}
    </header>
  );
};

export default HeaderNav;
